import { shiyong_url } from "@/components/const";
import { PageSubTitle, PageTitle } from "@/components/pageTitle";

export const Contact = () => {
  const copyEmail = (email: string) => {
    navigator.clipboard.writeText(email);
  };

  return (
    <div className="flex justify-center bg-[#EFF4FC]">
      <div className="w-[1920px]  py-[90px] ">
        <PageTitle title="联系我们" />
        <PageSubTitle title="杭州光年无界科技有限公司" />
        <div className="flex justify-between  mt-[130px]">
          {/* 吴志迪 */}
          <div className="w-[332px] h-[177px] bg-white rounded-[20px] p-[20px] flex gap-[20px] justify-between items-center">
            <div className="flex-1">
              <div className="flex items-center gap-[10px] font-[Alibaba\ PuHuiTi\ 3.0,Alibaba\ PuHuiTi\ 30] font-bold text-[25px] text-[#333333]">
                购买咨询
                <img src="/imgs/about/8.png" className="w-[40px] h-[40px]" />
              </div>
              <div className="mt-[10px] font-[Alibaba\ PuHuiTi\ 3.0,Alibaba\ PuHuiTi\ 30] font-regular text-[18px] text-[#333333]">
                吴先生
              </div>
              <div className="mt-[10px] font-[Alibaba\ PuHuiTi\ 3.0,Alibaba\ PuHuiTi\ 30] font-regular text-[18px] text-[#333333]">
                电话：17630811455
              </div>
            </div>
            <img src="/imgs/about/6.png" className="w-[95px] h-[95px]" />
          </div>
          {/* 黄鹏杰 */}
          <div className="w-[332px] h-[177px] bg-white rounded-[20px] p-[20px] flex gap-[20px] justify-between items-center">
            <div className="flex-1">
              <div className="flex items-center gap-[10px] font-[Alibaba\ PuHuiTi\ 3.0,Alibaba\ PuHuiTi\ 30] font-bold text-[25px] text-[#333333]">
                购买咨询
                <img src="/imgs/about/9.png" className="w-[40px] h-[40px]" />
              </div>
              <div className="mt-[10px] font-[Alibaba\ PuHuiTi\ 3.0,Alibaba\ PuHuiTi\ 30] font-regular text-[18px] text-[#333333]">
                黄先生
              </div>
              <div className="mt-[10px] font-[Alibaba\ PuHuiTi\ 3.0,Alibaba\ PuHuiTi\ 30] font-regular text-[18px] text-[#333333]">
                电话：18703822320
              </div>
            </div>
            <img src="/imgs/about/7.png" className="w-[95px] h-[95px]" />
          </div>
          {/* 邮箱 */}
          <div className="w-[332px] h-[177px] bg-white rounded-[20px] p-[20px] flex gap-[40px] justify-between items-center">
            <div className="flex-1">
              <div className="flex items-center gap-[10px] font-[Alibaba\ PuHuiTi\ 3.0,Alibaba\ PuHuiTi\ 30] font-bold text-[25px] text-[#333333]">
                合作邮箱
                <img src="/imgs/about/10.png" className="w-[40px] h-[40px]" />
              </div>
              <div className="mt-[10px] font-[Alibaba\ PuHuiTi\ 3.0,Alibaba\ PuHuiTi\ 30] font-regular text-[18px] text-[#333333]">
                cp@guangnianwujie.com
              </div>
              <a href={`mailto:cp@guangnianwujie.com`}>
                <div
                  onClick={() => copyEmail("cp@guangnianwujie.com")}
                  className="cursor-pointer mt-[10px] font-[Alibaba\ PuHuiTi\ 3.0,Alibaba\ PuHuiTi\ 30] font-regular text-[16px] text-center items-center justify-center text-[#0182FF] w-[87px] h-[30px] rounded-[8px] border-[2px] border-[#106BFF]"
                >
                  复制邮箱
                </div>
              </a>
            </div>
          </div>
          {/* 合作 */}
          <div className="w-[332px] h-[177px] bg-white rounded-[20px] p-[20px] flex gap-[40px] justify-between items-center">
            <div className="flex-1">
              <div className="flex items-center gap-[10px] font-[Alibaba\ PuHuiTi\ 3.0,Alibaba\ PuHuiTi\ 30] font-bold text-[25px] text-[#333333]">
                合作申请
                <img src="/imgs/about/11.png" className="w-[40px] h-[40px]" />
              </div>
              <div className="mt-[10px] font-[Alibaba\ PuHuiTi\ 3.0,Alibaba\ PuHuiTi\ 30] font-regular text-[18px] text-[#333333]">
                请填写您的合作需求
              </div>
              <a href={shiyong_url} target="_blank">
                <div className="mt-[10px] font-[Alibaba\ PuHuiTi\ 3.0,Alibaba\ PuHuiTi\ 30] font-regular text-[16px] text-center items-center justify-center text-[#0182FF] w-[87px] h-[30px] rounded-[8px] border-[2px] border-[#106BFF]">
                  申请合作
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
